import { MapPin, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCurrentShop } from '../contexts/CurrentShopContext';
import { ALL_SHOPS_ID } from '../utils/currentShop';

export function CurrentShopSelector() {
  const { t } = useTranslation();
  const { shops, loading, currentShopId, currentShop, isAllShopsMode, setCurrentShopId } =
    useCurrentShop();

  if (loading && shops.length === 0) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-400 px-2">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span className="hidden sm:inline">{t('common.loading')}</span>
      </div>
    );
  }

  if (shops.length === 0) return null;

  const selectTitle = isAllShopsMode
    ? t('planning.calendar.allShops', 'Tous les shops')
    : (currentShop?.name ?? t('planning.calendar.selectShop'));

  return (
    <div className="flex items-center gap-1 sm:gap-2 min-w-0 flex-1 lg:flex-initial max-w-[14rem] sm:max-w-xs">
      <MapPin className="w-4 h-4 text-primary-600 flex-shrink-0" aria-hidden />
      <label className="sr-only" htmlFor="current-shop-select">
        {t('planning.calendar.currentShopActive')}
      </label>
      <select
        id="current-shop-select"
        className="min-w-0 w-full lg:w-auto min-h-11 lg:min-h-0 text-sm border border-gray-200 rounded-lg px-2.5 py-1.5 bg-white text-gray-800 font-medium truncate max-w-full focus:outline-none focus:ring-2 focus:ring-primary-300"
        value={currentShopId ?? ''}
        onChange={(e) => {
          if (e.target.value) setCurrentShopId(e.target.value);
        }}
        title={selectTitle}
      >
        {!currentShopId && shops.length > 1 && (
          <option value="" disabled>
            {t('planning.calendar.selectShop')}
          </option>
        )}
        {shops.length > 1 && (
          <option value={ALL_SHOPS_ID}>
            {t('planning.calendar.allShops', 'Tous les shops')}
          </option>
        )}
        {shops.map((shop) => (
          <option key={shop.id} value={shop.id}>
            {shop.isActive === false
              ? `${shop.name} (${t('planning.calendar.inactiveShop', 'Inactif')})`
              : shop.name}
          </option>
        ))}
      </select>
    </div>
  );
}
